import React from 'react';
import {createRoot} from 'react-dom/client';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import {CookiesProvider} from 'react-cookie';
import {BrowserRouter as Router} from "react-router-dom";
import {queueAnalyticsInit} from './utils/analytics';

if (localStorage.getItem('camdiab-cookie-flag') === 'true'
    && localStorage.getItem('camdiab-cookie-denied') !== 'true') {
    queueAnalyticsInit();
}

const root = createRoot(document.getElementById('root'));
root.render(
    <CookiesProvider>
        <Router className="router-app">
            <App />
        </Router>
    </CookiesProvider>,
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();

